<template>
	<div class="topic_change_application">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page">
					<div class="content">
						<div class="row">
							<div class="col-12">
								<div class="page-title-box">
									<div class="page-title-right">
										<Breadcrumb />
									</div>
									<h3 class="header-title mb-3">课题变更申请</h3>
								</div>
								<!-- end page-title-box -->
							</div>
							<!-- end col-->
						</div>

						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">
										<div class="item_title">
											<div>
												<i class="el-icon-menu"></i>
												<span class="topic_level">【{{topicInfo.projectLevelName}}】</span>
											</div>
											<el-tooltip class="item" effect="dark" :content="topicInfo.declareName"
												placement="top">
												<div class="topic_title">{{ topicInfo.declareName }}</div>
											</el-tooltip>
											<span
												class="topic_time_range">（{{ getTimeRange(topicInfo.projectTime, topicInfo.expectedClosingTime) }}）</span>
											<span class="topic_project_number">立项编号:{{ topicInfo.projectNumber }}</span>
											<span class="learning_stages">学段:{{ topicInfo.learningTypeName }}</span>
											<span class="topic_discipline">学科:{{ topicInfo.disciplineName }}</span>
											<span class="topic_cate">类别:{{ topicInfo.projectTypeName }}</span>
										</div>
										<div class="item_body">
											<!-- 课题变更申请 -->
											<div class="change_request">
												<div class="change_request_title">
													<div>
														<i class="el-icon-menu"></i>
														<span class="topic_level">课题变更申请</span>
													</div>
													<el-button type="infor" @click="$router.go(-1)">返回</el-button>
												</div>
												<div class="change_request_body">
													<el-table :header-cell-style="tableStyle" border ref="multipleTable"
														:data="topicChangeApplicationList" tooltip-effect="dark"
														style="width: 100%" @selection-change="selectionChange">
														<!-- <el-table-column type="selection" width="55"></el-table-column> -->
														<el-table-column prop="oldDeclareName" label="课题名称" min-width="120"></el-table-column>
														<el-table-column prop="" label="变更事项" min-width="80">
															<template v-slot="scope">{{scope.row | getChange}}</template>
														</el-table-column>
														<el-table-column prop="createTime" label="申请时间" min-width="60"></el-table-column>
														<el-table-column prop="status" label="变更审批" min-width="50">
															<template v-slot="scope">
																{{ scope.row.status | getStatus }}
															</template>
														</el-table-column>
														<el-table-column prop="" label="操作" width="180">
															<template v-slot="scope">
																<el-button type="primary"
																	v-if="[0,1,3].includes(scope.row.status)"
																	@click="openUploadChangeTopicInfoDialog('edit',scope.row)">
																	修改</el-button>
																<el-button type="danger"
																	v-if="[0,1,3].includes(scope.row.status)"
																	@click="delTopicChangeRecord(scope.row.id)">删除
																</el-button>
															</template>
														</el-table-column>
													</el-table>
													<!-- <div class="pagination">
														<el-pagination
															@size-change="SizeChange"
															@current-change="CurrentChange"
															:current-page="listQuery.pageNumber"
															:page-sizes="[10, 50, 100]"
															:page-size="listQuery.pageSize"
															layout="total, sizes, prev, pager, next, jumper"
															:total="total"
														></el-pagination>
													</div> -->
													<div class="btn_wrap">
														<el-button type="primary"
															@click="openUploadChangeTopicInfoDialog('add')">申请
														</el-button>
													</div>
												</div>
											</div>
										</div>
									</div>
									<!-- end card-body-->
								</div>
								<!-- end card -->
							</div>
							<!-- end col-->
						</div>
					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
		<!-- 上传变更课题信息 -->
		<el-dialog title="变更课题信息" :visible.sync="uploadChangeTopicInfoDialogVisible" width="60%"
			:before-close="handleClose">
			<el-form :model="uploadChangeTopicInfoForm" :rules="uploadChangeTopicInfoRules"
				ref="uploadChangeTopicInfoFormRef" class="upload_change_topic_info_form">
				<el-row>
					<el-col :span="12" class="custom_table">变更前</el-col>
					<el-col :span="12" class="custom_table">变更后</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<span class="form_item_title">课题名称：</span>
						<span class="form_item_content">{{ topicInfo.declareName }}</span>
					</el-col>
					<el-col :span="12">
						<el-form-item label="新课题名称:" prop="newDeclareName">
							<el-input clearable v-model="uploadChangeTopicInfoForm.newDeclareName"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<span class="form_item_title">课题负责人：</span>
						<span class="form_item_content">{{ topicInfo.oneEmceeName }}</span>
					</el-col>
					<el-col :span="12">
						<el-form-item label="新课题负责人:" prop="newOneEmceeName">
							<el-input clearable @clear="clearNewOneEmceeValue"
								v-model="uploadChangeTopicInfoForm.newOneEmceeName" @focus="openEmceeDialog('one')">
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<!-- <el-row>
					<el-col :span="12">
						<span class="form_item_title">第二负责人：</span>
						<span
							class="form_item_content">{{ topicInfo.twoEmceeName ? `${topicInfo.twoEmceeName}(${topicInfo.twoUnitName})` : '无' }}</span>
					</el-col>
					<el-col :span="12">
						<el-form-item label="新第二负责人:" prop="newTwoEmceeValue">
							<el-input clearable @clear="clearNewTwoEmceeValue"
								v-model="uploadChangeTopicInfoForm.newTwoEmceeValue" @focus="openEmceeDialog('two')">
							</el-input>
						</el-form-item>
					</el-col>
				</el-row> -->
				<el-row>
					<el-col :span="12">
						<span class="form_item_title">承担单位：</span>
						<span class="form_item_content">{{ topicInfo.oneUnitName }}</span>
					</el-col>
					<el-col :span="12">
						<el-form-item label="新承担单位：" prop="name">
							<el-input v-model="uploadChangeTopicInfoForm.newOneUnitName" disabled></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<span class="form_item_title">申请延期：</span>
						<span class="form_item_content">{{ topicInfo.expectedClosingTime | getTime }}</span>
					</el-col>
					<el-col :span="12">
						<el-form-item label="延期时间：" prop="month">
							<el-select v-model="uploadChangeTopicInfoForm.month" clearable placeholder="请选择">
								<el-option v-for="item in delayTimeOptions" :key="item.id"
									:label="item.name | formatTime" :value="item.name"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-form-item label="变更申请扫描件：" label-width="150px" prop="annexId">
						<!-- <UpLoadImgOne @img-event="e => upLoadImgOne('annexId', e)" :value="uploadChangeTopicInfoForm.annexId" /> -->
						<UploadFile @file-event="e => upLoadFile(e)" :uploadFileAccept="uploadFileAccept" :value="uploadChangeTopicInfoForm.annexData" />
						<span class="tip">（限jpg、jpeg、png、gif、pdf格式）</span>
					</el-form-item>
				</el-row>
				<el-form-item label="申请说明：" prop="note" style="margin-top: 20px;">
					<el-input type="textarea" v-model="uploadChangeTopicInfoForm.note"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="uploadChangeTopicInfoDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitTopicChange">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 负责人选择对话框 -->
		<el-dialog :title="userDialogTitle" :visible.sync="userListDialogVisible" width="70%"
			:close-on-click-modal="false">
			<el-form :inline="true" ref="form" :model="userParams" label-width="80px">
				<el-form-item label="真实姓名">
					<el-input v-model="userParams.realName"></el-input>
				</el-form-item>
				<!-- <el-form-item label="登录名">
				  <el-input v-model="userParams.username"></el-input>
				</el-form-item> -->
				<!-- <el-form-item label="区域">
				  <el-cascader placeholder="请选择区域" v-model="userParams.region" clearable :props="{ value: 'id', label: 'name' }" :options="areaOptions" @change="areaChange"></el-cascader>
				</el-form-item> -->
				<el-form-item label="单位">
					<!-- <el-select v-model="userParams.unitId" :disabled="unitOptions.length===0" clearable filterable placeholder="请先选择区域">
				    <el-option v-for="item in unitOptions" :key="item.id" :label="item.unitName" :value="item.id"></el-option>
				  </el-select> -->
					<el-input v-model="userParams.unitName" placeholder="请输入单位名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="search">查询</el-button>
				</el-form-item>
			</el-form>
			<el-table border :data="userList" highlight-current-row @current-change="handleCurrentChange"
				style="width: 100%">
				<el-table-column type="index" width="50" label="#"></el-table-column>
				<el-table-column property="realName" label="姓名"></el-table-column>
				<el-table-column property="sex" label="性别">
					<template v-slot:default="scoped">
						{{ scoped.row.sex == 1 ? '男' : '女' }}
					</template>
				</el-table-column>
				<!-- <el-table-column property="username" label="用户名" width="120"></el-table-column> -->
				<!-- <el-table-column property="name" label="角色">
					<template slot-scope="scope">
						{{ scope.row.roleNames.join('、') }}
					</template>
				</el-table-column> -->
				<el-table-column property="unitName" label="单位"></el-table-column>
				<!-- <el-table-column property="address" label="状态">
					<template slot-scope="scope">
						{{ scope.row.status == 1 ? '可用' : '禁用' }}
					</template>
				</el-table-column> -->
			</el-table>

			<el-pagination style="text-align: center;margin-top: 20px;" @size-change="userListSizeChange"
				@current-change="userListPageNumberChange" :current-page="userParams.pageNumber"
				:page-sizes="[10, 20, 50]" :page-size="userParams.pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="userTotal"></el-pagination>

			<span slot="footer" class="dialog-footer">
				<el-button @click="userListDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirmUser">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
	import {
		getTopicChangeRecord,
		delTopicChangeRecordById,
		addOrEditTopicChangeRecord
	} from '@/api/after/topicManage.js';
	import {
		isHasNotFinishTopic
	} from '@/api/after/projectApplication.js';
	import {
		getPlatformInformationData,
		getUserList
	} from '@/api/after/systemManagement.js';
	import UploadFile from '@/components/upLoad/UploadFile.vue';
	export default {
		components: {Breadcrumb,UploadFile},
		data() {
			return {
				uploadFileAccept:'.jpg,.jpeg,.png,.gif,.pdf,.JPG,.JPEG,.PNG,.GIF,.PDF',//上传格式限制
				uploadChangeTopicInfoDialogVisible: false, //上传变更课题信息对话框
				uploadChangeTopicInfoForm: {
					newDeclareName: null,
					// newOneEmceeValue: null,
					newOneEmceeId: null,
					newOneEmceeName: null,
					// newOneUnitId: 0,
					// newOneUnitName: null,
					newTwoEmceeValue: null,
					newTwoEmceeId: null,
					// newTwoEmceeName: null,
					// newTwoUnitId: 0,
					// newTwoUnitName: null,
					// newExpectedClosingTime: null,
					month: null,
					annexId: null,
					// annexName: null,
					note: null
				},
				userListDialogVisible: false, //用户列表对话框
				userDialogTitle: '', //用户选择对话框标题
				curChangeEmcee: '', //当前选择的是第几负责人
				userParams: {
					//用户列表参数
					realName: '', //负责人姓名
					unitName: '', //负责人单位
					pageNumber: 1,
					pageSize: 10
				},
				userList: [], //用户列表
				userTotal: 0, //用户总数
				curSelectUser: {}, //当前选择的用户
				uploadChangeTopicInfoRules: {
					annexId: [{
						required: true,
						message: '请上传变更申请扫描件',
						trigger: 'change'
					}],
					note: [{
						required: true,
						message: '请输入申请说明',
						trigger: 'blur'
					}]
				},
				// 延期时间
				delayTimeOptions: [],
				tableStyle: {
					backgroundColor: '#4da7dc',
					color: '#fff',
					textAlign: 'center'
				},
				listQuery: {
					//参数
					pageNumber: 1,
					pageSize: 10
				},
				topicChangeApplicationList: [], //课题变更申请列表
				total: 0,
				topicInfo: {}, //课题数据
				curOperateType: ''
			};
		},
		filters: {
			getStatus(val) {
				switch (val) {
					case 0:
						return '初审未处理';
						break;
					case 1:
						return '初审不通过';
						break;
					case 2:
						return '终审未处理';
						break;
					case 3:
						return '终审不通过';
						break;
					case 4:
						return '终审通过';
						break;
					default:
						break;
				}
			},
			// 通过数据来判断课题哪些东西会变更
			getChange(val) {
				let str = ''
				str += val.newDeclareName?'课题名称':''
				str+=val.newOneEmceeId?(str?'、':'')+'第一负责人':'';
				str+=val.newTwoEmceeId?(str?'、':'')+'第二负责人':'';
				str+=val.month?(str?'、':'')+'延迟时间':'';
				return str
			}
		},
		computed: {
			getTimeRange(val1, val2) {
				return (val1, val2) => {
					if (val1) {
						return val1.slice(0, 7) + ' ~ ' + val2.slice(0, 7);
					}
				};
			}
		},
		created() {
			if (this.$route.query.data) {
				let data = JSON.parse(decodeURIComponent(this.$route.query.data));
				console.log('传递过来的数据', data);
				this.topicInfo = data;
				this.getDelayTime();
				this.getTopicChangeRecord();
			} else {
				this.$message.error('参数错误!');
				this.$router.go(-1);
			}
		},
		methods: {
			clearNewOneEmceeValue() {
				this.uploadChangeTopicInfoForm.newOneEmceeName = null
				this.uploadChangeTopicInfoForm.newOneEmceeId = null
				this.uploadChangeTopicInfoForm.newOneUnitName = null
			},
			clearNewTwoEmceeValue() {
				this.uploadChangeTopicInfoForm.newTwoEmceeValue = null
				this.uploadChangeTopicInfoForm.newTwoEmceeName = null
				this.uploadChangeTopicInfoForm.newTwoUnitName = null
				this.uploadChangeTopicInfoForm.newTwoEmceeId = null
				this.$forceUpdate()
			},
			// 删除课题变更记录
			delTopicChangeRecord(id) {
				this.$confirm('确定删除当课题变更记录？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(async () => {
						const res = await delTopicChangeRecordById(id);
						if (res.code == 200) {
							this.$message.success('删除成功！');
							this.getTopicChangeRecord();
						} else {
							this.$message.error(res.data);
						}
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});
			},
			// 提交课题变更申请
			submitTopicChange() {
				this.$refs.uploadChangeTopicInfoFormRef.validate(valid => {
					if (valid) {
						let params = JSON.parse(JSON.stringify(this.uploadChangeTopicInfoForm))
						// 补充课题旧数据
						params.projectManagementId = this.topicInfo.id;
						params.oldDeclareName = this.topicInfo.declareName;
						params.oldOneEmceeId = this.topicInfo.oneEmceeId;
						params.oldOneEmceeName = this.topicInfo.oneEmceeName;
						params.oldOneUnitId = this.topicInfo.oneUnitId;
						params.oldOneUnitName = this.topicInfo.oneUnitName;
						params.oldTwoEmceeId = this.topicInfo.twoEmceeId;
						params.oldTwoEmceeName = this.topicInfo.twoEmceeName;
						params.oldTwoUnitId = this.topicInfo.twoUnitId;
						params.oldTwoUnitName = this.topicInfo.twoUnitName;
						params.oldExpectedClosingTime = this.topicInfo.expectedClosingTime;
						console.log('课题变更数据', params);
						let isChangeTopicName = Boolean(params.newDeclareName);
						let isChangeEmcee = params.newOneEmceeId !== '' || params.newTwoEmceeId !== '';
						let isChangeDelayTime = params.month !== '';
						console.log(isChangeTopicName, isChangeEmcee, isChangeDelayTime);
						if (isChangeTopicName || isChangeEmcee || isChangeDelayTime) {
							this.addOrEditTopicChangeRecord(params)
						} else {
							this.$message.error('请至少变更课题名称、课题负责人、申请延期其中之一！');
							return;
						}
					}
				});
			},
			// 添加或者修改课题变更修改
			async addOrEditTopicChangeRecord(data) {
				const res = await addOrEditTopicChangeRecord(data);
				if (res.code == 200) {
					if (this.curOperateType === 'add') {
						this.$message.success('添加课题变更申请成功！');
					} else if (this.curOperateType === 'edit') {
						this.$message.success('修改课题变更申请成功！');
					}
					this.uploadChangeTopicInfoDialogVisible = false
					this.getTopicChangeRecord()
				} else {
					this.$message.error(res.data);
				}
			},
			// 确认选择用户
			confirmUser() {
				console.log('当前选择的用户', this.curSelectUser);
				if (this.curChangeEmcee === 'one') {
					this.uploadChangeTopicInfoForm.newOneEmceeName = this.curSelectUser.realName;
					this.uploadChangeTopicInfoForm.newOneEmceeId = this.curSelectUser.id;
					this.uploadChangeTopicInfoForm.newOneUnitName = this.curSelectUser.unitName;
				} else if (this.curChangeEmcee === 'two') {
					this.uploadChangeTopicInfoForm.newTwoEmceeValue =
						`${this.curSelectUser.realName}(${this.curSelectUser.unitName})`;
					this.uploadChangeTopicInfoForm.newTwoEmceeName = this.curSelectUser.realName
					this.uploadChangeTopicInfoForm.newTwoUnitName = this.curSelectUser.unitName
					this.uploadChangeTopicInfoForm.newTwoEmceeId = this.curSelectUser.id;
				}
				this.userListDialogVisible = false;
			},
			// 打开负责人对话框
			openEmceeDialog(type) {
				type === 'one' ? (this.userDialogTitle = '请选择第一负责人') : (this.userDialogTitle = '请选择第二负责人');
				this.curChangeEmcee = type;
				this.getUserList(this.userParams);
				this.userListDialogVisible = true;
			},
			// 用户单选
			async handleCurrentChange(val) {
				const res = await isHasNotFinishTopic(val.id);
				if (res.code == 200) {
					this.curSelectUser = val;
					this.$message.success('当前用户可以选择！');
				} else {
					this.curSelectUser = {};
					this.$message.error(res.data + '，请重新选择！');
				}
			},
			// 用户搜索
			search() {
				console.log(this.userParams);
				let params = JSON.parse(JSON.stringify(this.userParams));
				// params.region = params.region[params.region.length-1]
				params.pageNumber = 1;
				console.log('处理后数据', params);
				this.getUserList(params);
			},
			// 获取用户列表
			async getUserList(data) {
				const res = await getUserList(data);
				if (res.code == 200) {
					console.log('用户列表', res);
					this.userList = res.data.records;
					this.userTotal = res.data.total;
				} else {
					this.$message.error(res.data);
				}
			},
			userListSizeChange(val) {
				this.userParams.pageSize = val;
				this.getUserList(this.userParams);
			},
			userListPageNumberChange(val) {
				this.userParams.pageNumber = val;
				this.getUserList(this.userParams);
			},
			// 获取配置文件延迟时间
			async getDelayTime() {
				const res = await getPlatformInformationData(11);
				if (res.code == 200) {
					this.delayTimeOptions = res.data;
				} else {
					this.$message.error(res.data);
				}
			},
			// 获取课题变更记录
			async getTopicChangeRecord() {
				const res = await getTopicChangeRecord(this.topicInfo.id);
				if (res.code == 200) {
					console.log('课题变更记录', res);
					this.topicChangeApplicationList = res.data;
				} else {
					this.$message.error(res.data);
				}
			},
			// 打开上传变更课题信息对话框
			openUploadChangeTopicInfoDialog(type, data) {
				if (type === 'edit') {
					if (data.newTwoEmceeId) {
						data.newTwoEmceeValue = `${data.newTwoEmceeName}(${data.newTwoUnitName})`
					} else {
						data.newTwoEmceeValue = null
					}
					if (!data.month) {
						data.month = null
					}
					data.annexData={
						id:data.annexId,
						name:data.annexName,
					}
					this.uploadChangeTopicInfoForm = data;
					console.log(this.uploadChangeTopicInfoForm);
				} else {
					this.uploadChangeTopicInfoForm = {
						newDeclareName: null,
						newOneEmceeId: null,
						newOneEmceeName: null,
						newTwoEmceeValue: null,
						newTwoEmceeId: null,
						month: null,
						annexId: null,
						note: null
					}
				}
				this.curOperateType = type;
				this.uploadChangeTopicInfoDialogVisible = true;
			},
			// 上传扫描原件
			upLoadFile( data) {
				this.uploadChangeTopicInfoForm.annexId = data.id;
				this.uploadChangeTopicInfoForm.annexName = data.name;
			},
			SizeChange(val) {},
			CurrentChange(val) {},
			// 多选
			selectionChange(val) {},
			// 关闭上传报告对话框
			handleClose(done) {
				this.$confirm('确认关闭？')
					.then(_ => {
						done();
					})
					.catch(_ => {});
			}
		}
	};
</script>

<style scoped lang="scss">
	.item_title {
		display: flex;
		align-items: center;
		// justify-content: space-between;
		border-bottom: 1px solid #eee;
		height: 50px;

		.topic_level {
			font-weight: bolder;
		}

		.topic_title {
			font-size: 16px;
			max-width: 300px;
			text-overflow: ellipsis;
			white-space: nowrap;
			overflow: hidden;
		}

		.topic_time_range {}

		.topic_project_number {}

		.learning_stages {}

		.topic_discipline {}

		.topic_cate {}
	}

	.process_materials_title,
	.change_request_title {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 10px 0;
	}

	.btn_wrap {
		margin-top: 10px;
	}

	.custom_table {
		height: 40px;
		line-height: 40px;
		text-align: center;
		background-color: #d0e4f5;
		color: #2d87bd;
	}

	.upload_change_topic_info_form {
		::v-deep .el-form-item {
			margin-bottom: 0;
		}

		::v-deep .el-row {
			display: flex;
			align-items: center;
			padding: 10px 0;
			border: 1px solid #dfedfc;
		}

		::v-deep .el-row:first-child {
			padding: 0 !important;
		}

		.form_item_title {
			display: inline-block;
			width: 130px;
			padding-right: 10px;
			text-align: right;
		}

		.tip {
			color: red;
		}
	}
</style>
